import { isNumber } from '@AMIEWEB/Placement/PlacementDetails/PlacementTabPanel/ModificationsTab/ModificationsUtils';

export const validNewUnitResponse = unitResponse => {
  return isNumber(unitResponse?.unitId) && unitResponse?.unitId > 0;
};
